<script setup lang="ts">
import type { BookAndArticle } from '~/utils/solr/literature'

const props = defineProps<{
  book: BookAndArticle
}>()

const authors = computed(() => {
  return props.book.author?.map(author => ({
    name: author,
    slug: author.replace(/\./g, '').replace(/\s+/g, '-').toLocaleLowerCase(),
  }))
})
</script>

<template>
  <div class="flex flex-col items-center gap-m py-m">
    <LiteratureCard
      :to="{ name: 'book-by-id', params: { bokId: [book.id] } }"
      :title="book.title ?? ''"
      :image="book.coverImage ?? ''"
      :edition-number="book.editionNumber ?? '' "
      :release-year="book.year"
      :authors="authors"
      layout="reading"
      size="small"
      class="relative"
    />
  </div>
</template>
